var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22247(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22247",
    "data-name": "Group 22247",
    transform: "translate(-547 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22241",
    "data-name": "Group 22241",
    transform: "translate(252 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(570.718 2069.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1 1.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27653",
    "data-name": "Path 27653",
    d: "M1.129,6.685H7.9V26.442H1.129c-.624,0-1.129-.68-1.129-1.52V8.205C0,7.366.505,6.685,1.129,6.685Z",
    transform: "translate(0 6.523)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27654",
    "data-name": "Path 27654",
    d: "M4,14.69,10.519,2.059a3.8,3.8,0,0,1,6.068-.945h0a5.927,5.927,0,0,1,1.736,4.191v5.927H28.7a2.964,2.964,0,0,1,2.941,3.331L29.415,30.37a2.963,2.963,0,0,1-2.941,2.6H4",
    transform: "translate(3.903 0)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22247);
export default __webpack_public_path__ + "static/media/Group 22247.0179325c00e8e57168e5f0b76d16878a.svg";
export { ForwardRef as ReactComponent };